module.exports = __webpack_public_path__ + "static/media/billing.b4999930.gif";